
import Request from './Request';

export default class ExternalEvents {
  constructor(root) {
    this.root = root;
    this.url = this.root.dataset.url;
    this.viewAllButton = this.root.querySelector('.js-view-all-button');
    this.eventNumber = this.root.dataset.number;
    this.resultsContainer = this.root.querySelector('.js-external-events-container');
    this.daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fr', 'Sat'];
    this.events = '';

    new Request(`${this.url}/wp-json/tribe/events/v1/events/?page=1&per_page=${this.eventNumber}`).then((response) => {
      const events = response['response'];
      const headers = response['headers'];
      const eventsToDisplay = events.events;


      if (eventsToDisplay.length > 0) {

        this.resultsContainer.innerHTML = '';

        eventsToDisplay.forEach(event => {
          this.resultsContainer.appendChild(this.buildEvent(event));
        });

        if (Boolean(this.viewAllButton)) {
          this.viewAllButton.classList.add('--active');
        }
      } else {
        this.resultsContainer.innerHTML = '<div>There are no events available at this time.</div>';
      }


    }).catch((error) => {
      //error
      console.log(error);
      this.resultsContainer.innerHTML = '<div>Events could not be loaded at this time. Please try again later.</div>';
    });
  }

  buildEvent(eventObj) {
    const event = document.createElement('div');
    event.classList.add('external-events-block__single-event');

    const title = eventObj.title;
    const url = eventObj.url;
    // Start date
    const startDateObj = new Date(eventObj.start_date);
    const startDayOfWeek = startDateObj.getDay();
    const startDayName = this.daysOfWeek[startDayOfWeek];
    const startDayOfMonth = startDateObj.getDate();
    const startMonthName = startDateObj.toLocaleString('default', { month: 'long' });
    const startTime = startDateObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).toLowerCase();
    const startDateMarkup = `${startMonthName} ${startDayOfMonth} @ ${startTime} - `
    // End date
    const endDateObj = new Date(eventObj.end_date);
    const endTime = endDateObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).toLowerCase();
    let endDateMonth = '';
    let endDateDay = '';
    let endDateFull = '';
    let endDateMarkup = '';

    if (startDateObj.getFullYear() !== endDateObj.getFullYear() ||
      startDateObj.getMonth() !== endDateObj.getMonth() ||
      startDateObj.getDate() !== endDateObj.getDate()) {

      endDateMonth = endDateObj.toLocaleString('default', { month: 'long' });
      endDateDay = endDateObj.getDate();
      endDateFull = `${endDateMonth} ${endDateDay} @`;

    }

    endDateMarkup = `${endDateFull} ${endTime}`

    event.innerHTML = `
        <!--Start date-->
        <div class="external-events-block__single-event__start-date">
            <div class="external-events-block__single-event__start-date__day-text">${startDayName}</div>
            <div class="external-events-block__single-event__start-date__day-number">${startDayOfMonth}</div>
        </div>
        <!-- End Start date-->

        <!--Event Info-->
        <div class="external-events-block__single-event__event-info">

            <!--Event Title-->
            <a class="external-events-block__single-event__event-info__title" href="${url}" target="_blank" rel="nofollow">
                ${title}
            </a>

            <!--Event start-end date-->
            <div class="external-events-block__single-event__event-info__dates">
                ${startDateMarkup} ${endDateMarkup}
            </div>

        </div>
        <!--End Event Info-->
    `;

    return event;
  }

}
